export enum RegistrationStatus {
    REGISTERED = 'REGISTERED',
    UNREGISTERED = 'UNREGISTERED',
}
